import '../styles/components/result-stats.css';

// Age estimation outcomes → display labels + colors
const AGE_LABELS = {
  both_images: { label: 'Both Images', color: 'var(--green)' },
  website_only: { label: 'Website Only', color: 'var(--accent)' },
  linkedin_only: { label: 'LinkedIn Only', color: 'var(--accent)' },
  'not_found': { label: 'Not Found', color: 'var(--text3)' },
  failed: { label: 'Failed', color: 'var(--red)' },
};

// Discovery outcomes → display labels + colors
const DISCOVERY_LABELS = {
  confirmed: { label: 'Confirmed', color: 'var(--green)' },
  probable: { label: 'Probable', color: 'var(--yellow)' },
  ambiguous: { label: 'Ambiguous', color: 'var(--accent)' },
  'not_found': { label: 'Not Found', color: 'var(--text3)' },
  error: { label: 'Error', color: 'var(--red)' },
};

export default function ResultStats({ stats, mode }) {
  if (!stats || Object.keys(stats).length === 0) return null;

  const labels = mode === 'discovery' ? DISCOVERY_LABELS : AGE_LABELS;

  // All known labels (0 if missing), then any unknown from stats
  const knownKeys = Object.keys(labels);
  const entries = [
    ...knownKeys.map(k => ({ key: k, count: stats[k] || 0, ...labels[k] })),
    ...Object.keys(stats)
      .filter(k => !labels[k])
      .map(k => ({ key: k, count: stats[k], label: k, color: 'var(--text2)' })),
  ];

  return (
    <div className="result-stats">
      {entries.map(e => (
        <div key={e.key} className="result-stats-card">
          <div className="result-stats-label" style={{ color: e.color }}>{e.label}</div>
          <div className="result-stats-count" style={{ color: e.color }}>{e.count}</div>
        </div>
      ))}
    </div>
  );
}
